import React, { useEffect, useState } from 'react';
import logoGala from '../assets/common/LogoGala.png';
import './auth.css';

// Cible de l'ancienne icône 📋 des e-mails : un e-mail ne peut pas copier lui-même,
// il ouvrait cette page, qui copie le code passé en fragment. Les e-mails ont
// désormais un bouton qui ouvre la bonne page code déjà saisi (utils/emailCodeLink) ;
// la page reste pour les invitations à l'étude déjà envoyées, gardées des mois.
//
// Le fragment ne quitte jamais le navigateur ; on l'efface de l'adresse dès la
// lecture pour qu'il ne reste pas dans l'historique. Aucune API n'est appelée :
// ouvrir la page ne consomme pas le code.

// Couvre les codes à 6 chiffres comme les codes de participation de l'étude
// (SPORTIVE_48213) — même motif que SurveyWizard.jsx::CODE_PATTERN.
const CODE_PATTERN = /^[A-Za-z0-9_-]{3,32}$/;

function lireCode() {
  try {
    const brut = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    return CODE_PATTERN.test(brut) ? brut : null;
  } catch {
    return null;
  }
}

const CopierCode = () => {
  const [code] = useState(lireCode);
  const [etat, setEtat] = useState('attente'); // attente | copie | echec

  // `manuel` : un échec après un clic se signale ; celui de la tentative automatique
  // non — Safari refuse toute copie sans geste, le bouton est là pour ça.
  const copier = async (manuel) => {
    try {
      await navigator.clipboard.writeText(code);
      setEtat('copie');
    } catch {
      if (manuel) setEtat('echec');
    }
  };

  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    if (code) copier(false);
    // Une seule fois, à l'ouverture.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page">
      <div className="container">
        <div className="signup-logo">
          <img src={logoGala} alt="CycleGala" className="signup-logo-image" />
        </div>
        <h2 className="signup-brand">
          <span className="signup-brand--cycle">Cycle</span>
          <span className="signup-brand--gala">Gala</span>
        </h2>

        {code ? (
          <>
            <p className="subtitle">Votre code</p>
            <p className="copy-code__value">{code}</p>
            <div className="button-group">
              <button type="button" className="btn btn--primary" onClick={() => copier(true)}>
                {etat === 'copie' ? 'Code copié ✓' : 'Copier le code'}
              </button>
            </div>
            {etat === 'copie' && (
              <p className="auth-hint" role="status">
                C'est copié. Revenez sur l'onglet CycleGala et collez le code.
              </p>
            )}
            {etat === 'echec' && (
              <p className="auth-hint" role="alert">
                Votre navigateur refuse la copie : appuyez longuement sur le code pour le sélectionner.
              </p>
            )}
          </>
        ) : (
          <p className="subtitle">
            Aucun code à copier. Rouvrez le lien depuis l'e-mail reçu.
          </p>
        )}
      </div>
    </div>
  );
};

export default CopierCode;
